<!-- Dashboard -->
<div class="ui-dashboard m-b-20" *ngIf="enableDashboard">
  <div class="-ocr-dashboard-wrapper">
    <div class="p-b-20 d-b">
      <section class="dashboard-header-section">
        <div class="grid grid-gap-20 grid-3x grid-3x-responsive p-b-0 sticky-banner">

          <!-- LHS -->
          <div style="grid-column-start: 1;grid-column-end: 3;">
            <h2 class="dashboard-head">Intelligent Document Processing (IDP) Console</h2>
          </div>

          <!-- RHS -->
          <div class="text-a-right">
            <div class="">
              <button nz-button nzType="primary" nzPlacement="bottomRight" (click)="claimViaOCR('OCRUpload')">
                {{transactionConfigData?.TransactionDetailsMetaData[transactionState]
                  ? transactionConfigData.TransactionDetailsMetaData[transactionState].buttonName : "Process New Documents" }} 
              </button>
            </div>
          </div>
        </div>
        <div class="flex m-t-10" style="justify-content: space-between;">
          <span></span>
          <section class="text-a-right m-b-15">
            <nz-range-picker [(ngModel)]="dateRangeForFWAGraph" (ngModelChange)="setDateRange($event)"
              [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR" style="width : 260px !important;">
            </nz-range-picker>
            <!-- <nz-divider nzType="vertical"></nz-divider> -->
           
          </section>
        </div>
      </section>
      <section>
        <ng-container *ngIf="isLoading">
          <div class="widget-loading" *ngFor="let i of [1];" style="height:150px">
            <p><i nz-icon nzType="loading" theme="outline"></i>&nbsp; Loading Console...</p>
          </div>
        </ng-container>
        <div class="flex m-10" style="justify-content: space-between;">
          <span class="heading-pc">Total cases processed with IDP : {{totalCases}}</span>
          <div class="text-a-right">
            
            <nz-switch [(ngModel)]="expandPanel" (ngModelChange)="expandCard($event)"
                  class="m-r-5"></nz-switch> <span class="p-r-20">{{expandPanel ? 'Hide Dashboard' : 'Show Dashboard'}}</span>  
            <nz-divider nzType="vertical"></nz-divider> 
            <nz-select style="display: inline-block; text-align: left; width: 150px;"
              nzPlaceHolder="Select Color Scheme" [(ngModel)]="colorSchemeTempModel"
              (ngModelChange)="colorSchemeModelChange()">
              <nz-option *ngFor="let cs of colorSchemesNames; let i=index;" [nzValue]="i" [nzLabel]="cs"></nz-option>
            </nz-select>
              
          </div>
        </div>
        <div *ngIf="!isLoading && dashboardItemsList" class="grid grid-4x-width grid-4x-responsive grid-gap-20">
          <ng-container class="" *ngFor="let data of dashboardItemsList; let i = index;">
            <!-- Head -->
            <div class="widget widget-shadow" [ngStyle]="{ 'backgroundColor': colorScheme.domain[i] }">
              <nz-collapse [nzBordered]="false" class="panel-custom-unified" [nzGhost]="true" [nzDisable]="true"
                [ngStyle]="{ 'backgroundColor': colorScheme.domain[i] }">
                <nz-collapse-panel #p [nzActive]="expandPanel" [nzHeader]="expandedDetails" [ngStyle]=""
                  [nzExpandedIcon]="expandedIcon" (click)="expandCard('All')">
                  <ng-template #expandedDetails let-active>
                  <div class="widget-head">
                      <!-- <div class="grid grid-2x grid-2x-responsive m-t-10" style="grid-gap:200px;"> -->
                          <!-- <div class="flex" style="justify-content: space-between;"> -->
                              <!-- <div class="flex p-l-10" style="font-size:16px;justify-content: space-between;"> -->
                                  <h3 class="heading-pc heading-pc-color-light">{{data.name}}s</h3>
                                  <h3 class="heading-pc heading-pc-color-light">{{data.totalCount}}</h3>
                              <!-- </div> -->
                          <!-- </div> -->
                  
                  </div>
                  </ng-template>
                  <ng-template #expandedIcon let-active>
                    <span nz-icon nzType="down-circle" style="color:#fff;top:40%"
                      class="ant-collapse-arrow card-arrow" [nzRotate]="p.nzActive ? 0 : 180"></span>
                  </ng-template>

                  <div class="rule-count-card-section">
                      <div class="rule-count-card-area">
                        <div class="rule-count-card-pie-graph" *ngIf="!isLoading && data && data.details && data.details.length > 0">
                          <!-- <span>{{data.details | json}}</span> -->
                          <ngx-charts-pie-chart [view]="[200,200]" [scheme]="chartColorScheme" [results]="data.details"
                            legend="true" legendPosition="bottom" doughnut="true" [legendTitle]="data.name">
                          </ngx-charts-pie-chart>
                        </div>
                        <ul class="rule-count-card-list" *ngIf="false">
                          <li class="stat-widget">
                            <div class="stat-widget-body">
                              <!-- <strong>{{data.name}}</strong> -->
                              Status count
                            </div>
                            <div class="stat-widget-footer">
                              <table class="w-100-pc">
                               <tr *ngFor="let row of data.details; let i=index;">
                               <td>{{row.name}}</td>
                               <td class="text-a-right">{{row.value}}</td>
                               </tr>                
                              </table>
                            </div>
                          </li>
                        </ul>
                       
                      </div>
                  </div>
                </nz-collapse-panel>
              </nz-collapse>
            </div>
          </ng-container>
        </div>
      </section>
    </div>
  </div>
</div>


<!-- Search and NEW -->
<div class="flexie-auto-grid p-b-20">
  <div>
    <h3 translate>Search {{transactionConfigData?.TransactionDetailsMetaData[transactionState]
      ? transactionConfigData.TransactionDetailsMetaData[transactionState].tableHeading : "data" }}</h3>
      <i style="font-size: 10px;"><i nz-icon nzType="exclamation-circle" class="ico-item"></i> By using the criteria from
      dropdown below you can search existing
      {{transactionConfigData?.TransactionDetailsMetaData[transactionState]
      ? transactionConfigData.TransactionDetailsMetaData[transactionState].tableHeading : "data"}}.</i>
      <div class="m-t-10" style="width: 650px;">
        <app-ui-search class="m-t-10" [(SearchCriteria)]="CRITERIALOOKUP" (componentOutput)="fetchSearchResult($event)"
          [searchURL]="transactionConfigData?.TransactionDetailsMetaData[transactionState]?.searchURL"
          itemsPerPage='20'></app-ui-search>
      </div>
  </div>
  <div *ngIf="false" class="text-a-right">
    <!-- <button *ngIf="viewType != 'ENQUIRY'" nz-button [nzType]="'primary'" (click)="NewIntimation('workbench')" translate>
      <i nz-icon nzType="plus"  nzTheme="outline"></i> New Intimation
    </button> -->
    <button *ngIf="viewType != 'ENQUIRY'" nz-button [nzType]="'primary'" (click)="NewIntimation('workbench')" translate>
      <i nz-icon nzType="plus"  nzTheme="outline"></i>{{transactionConfigData?.TransactionDetailsMetaData[transactionState]
        ? transactionConfigData.TransactionDetailsMetaData[transactionState].buttonName : "New Intimation" }} 
    </button>
  </div>
  <div *ngIf="viewType != 'ENQUIRY'" class="text-a-right">
    <button nz-button nzType="primary" nzPlacement="bottomRight" (click)="claimViaOCR('OCRUpload')">
      {{transactionConfigData?.TransactionDetailsMetaData[transactionState]
        ? transactionConfigData.TransactionDetailsMetaData[transactionState].buttonName : "New IDP" }} 
    </button>
    <nz-dropdown-menu #newIntimationDropdown="nzDropdownMenu">
      <ul nz-menu nzSelectable>
        <li nz-menu-item (click)="NewIntimation('workbench')">New Intimation</li>
        <li nz-menu-item (click)="claimViaOCR('OCRUpload')">Intimation via OCR</li>
      </ul>
    </nz-dropdown-menu>
  </div>
</div>

<!-- <h3 class="heading" translate>Last 5 Intimations</h3> -->
<!-- <h3 class="heading" translate>Latest Intimations Worked On</h3> -->
<div class="heading-tab p-t-5 p-b-15">
  <h3 class="heading" translate>Latest {{transactionConfigData?.TransactionDetailsMetaData[transactionState]
    ? transactionConfigData.TransactionDetailsMetaData[transactionState].tableHeading : "Intimations" }} Worked On
    <span *ngIf="dataSet && dataSet.length">({{dataSet.length}})</span></h3>

  <div>
    <button nz-button nz-dropdown nzPlacement="topCenter" [nzDropdownMenu]="manageHeadersMenu">View/Hide
      Columns<i nz-icon nzType="down"></i></button>
    <nz-dropdown-menu #manageHeadersMenu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item style="text-align: right;">
          <a [class.anchor-is-disabled]="!isAtleastOneHeaderIsChecked" style="font-size: 16px;font-weight: 500;"
            (click)="unselectAll()">Clear</a>
          <!-- <label [nzDisabled]="!isAtleastOneHeaderIsChecked" [(ngModel)]="unselectAllHeaders" (click)="unselectAll()">
              Clear
            </label> -->
        </li>
        <nz-divider class="m-0-force"></nz-divider>
        <li nz-menu-item *ngFor="let config of observationDataSet; let index = i">
          <label nz-checkbox [nzDisabled]="lastCheckboxPendingToBeUnticked() && config.isVisible"
            [(ngModel)]="config.isVisible" (ngModelChange)="manageHeaders($event)">{{config.header}}</label>
        </li>
      </ul>
    </nz-dropdown-menu>
  </div>
</div>

<nz-table #intimationSearchTable [nzSize]="'middle'" nzTemplateMode [nzFrontPagination]="dataSet && dataSet.length > 5 ? true : false" 
  [nzScroll]="{x : '900px'}">
  <thead>
    <tr>
      <ng-container *ngFor="let config of observationDataSet; let index = i">
        <th *ngIf="viewType == 'ENQUIRY' && config.isVisible" [nzWidth]="'130px'">
          <div class="search-header-container">
            <div class="search-title">{{config.header}}</div>
            <div class="search-buttons">
              <ng-container [ngTemplateOutlet]="columnActions" [ngTemplateOutletContext]="{ config }"></ng-container>
            </div>
          </div>
        </th>
        <th *ngIf="viewType != 'ENQUIRY' && !config.enquiryTab && config.isVisible" [nzWidth]="'130px'">
          <div class="search-header-container">
            <div class="search-title">{{config.header}}</div>
            <div class="search-buttons">
              <ng-container [ngTemplateOutlet]="columnActions" [ngTemplateOutletContext]="{ config }"></ng-container>
            </div>
          </div>
        </th>
      </ng-container>
      <th scope="col" nzRight="0px" nzAlign="center" [nzWidth]="'130px'" class="text-a-center fixed-width">Actions</th>
    </tr>
  </thead>
  <tbody>
      <tr *ngFor="let data of dataSet">
        <!-- {{data | json}} -->
        <ng-container *ngFor="let config of observationDataSet; let index = i">
          <td *ngIf="config.isVisible">
            <span *ngIf="data[config.key] && config.pipe == 'DATE'">{{getDateString(data[config.key])}}</span>
            <span *ngIf="data[config.key] && config.pipe == 'TEXT'">{{data[config.key]}}</span>
            <!-- <span *ngIf="config.showLink">{{data[config.key]}}</span> -->
            <!-- <span *ngIf="!config.isDate && !config.pipe && config.key2">&nbsp;{{data[config.key2]}}</span> -->
            <span *ngIf="config.pipe && config.pipe == 'LOOKUP' && !config.lookupName">{{(data[config.key] | technicalTranslate)}}</span>
            <span *ngIf="config.pipe && config.pipe == 'LOOKUP' && config.lookupName ">{{(data[config.key] | technicalTranslate : config.lookupName)}}</span>
            <span *ngIf="data[config.key] && config.pipe && config.pipe == 'CurrencyFormatter'">{{(data[config.key] | CurrencyFormatter)}}</span>
            <span *ngIf="!data[config.key]" class="nodatafound">No data found</span>
          </td>
        </ng-container>
          <td nzRight="0px" nzAlign="center" class="text-a-center fixed-width">
            <a nz-dropdown [nzDropdownMenu]="menu">Actions
               <i nz-icon nzType="down"></i>
             </a>
             <nz-dropdown-menu #menu="nzDropdownMenu">
               <ul nz-menu nzSelectable>
                 <li *ngIf="!userRole" (click)="openTransactionDetails(data,'search')"  nz-menu-item>Open Transaction</li>
                 <!-- <li nz-menu-item (click)="activityPanel(1,data.guid)">Activity Timeline</li> -->
               </ul>
             </nz-dropdown-menu>
         </td>
      </tr>
  </tbody>
</nz-table>

<app-generic-zero-ui [list]="dataSet" icon="file-search" 
[title]="intimationZeroState.title" [message]="intimationZeroState.message" [icon]="intimationZeroState.icon"></app-generic-zero-ui>

<ng-template let-config="config" #columnActions>
  <!-- <div> -->
    <button class="action-button" nz-button nz-dropdown [nzDropdownMenu]="sortMenu" nzSize="small">
      <i class="rotate-90" nz-icon nzType="swap" nzTheme="outline"></i>
    </button>
    <button class="action-button" nz-button nz-dropdown [nzDropdownMenu]="filterMenu" nzSize="small">
      <i nz-icon nzType="search" nzTheme="outline"></i>
    </button>
  <!-- </div> -->
  <nz-dropdown-menu #sortMenu="nzDropdownMenu">
    <ul nz-menu class="grid grid-2x grid-gap-5">
      <li nz-menu-item (click)="sortColumn(config, 'asc')">
        <i nz-icon nzType="sort-ascending" nzTheme="outline"></i>
      </li>
      <li nz-menu-item (click)="sortColumn(config, 'desc')">
        <i nz-icon nzType="sort-descending" nzTheme="outline"></i>
      </li>
    </ul>
  </nz-dropdown-menu>
  <nz-dropdown-menu #filterMenu="nzDropdownMenu">
    <div class="m-5 p-5 b-r-4 flex-inline flex-horiz-space-bw flex-vert-center filter-container">
      <input nz-input placeholder="Filter..." nzSize="small" [(ngModel)]="config.filterQuery"
        (ngModelChange)="filterColumn(config)" />
      <a class="m-l-5" (click)="clearFilter(config)"><i nz-icon nzType="close-circle" nzTheme="outline"></i></a>
    </div>
  </nz-dropdown-menu>
</ng-template>

<!--Activity log  -->
<nz-drawer [nzClosable]="true" [nzWidth]="400" [nzPlacement]="'right'" nzTitle="{{'Activity Timeline' | MMSTranslate}}"
  [nzVisible]="activityPanelOpen" (nzOnClose)="activityPanel(0)">
  <ng-container *nzDrawerContent>
    <app-claims-activity-timeline [IO]="initialPayloadInEdit"
      transactionState="activity"></app-claims-activity-timeline>
  </ng-container>
</nz-drawer>